/**
 * Do not edit directly
 * Generated on Tue, 23 Jul 2024 13:51:28 GMT
 */

module.exports = {green : {100:{
            name: "green.100",
            hex: "#0C291E",
            
          },200:{
            name: "green.200",
            hex: "#124935",
            
          },300:{
            name: "green.300",
            hex: "#1F5B45",
            
          },400:{
            name: "green.400",
            hex: "#206A4F",
            
          },500:{
            name: "green.500",
            hex: "#288563",
            
          },600:{
            name: "green.600",
            hex: "#42AD86",
            
          },700:{
            name: "green.700",
            hex: "#BFE8D9",
            
          },800:{
            name: "green.800",
            hex: "#F0FFF9",
            
          }},
blue : {100:{
            name: "blue.100",
            hex: "#0C1B29",
            
          },200:{
            name: "blue.200",
            hex: "#102337",
            
          },300:{
            name: "blue.300",
            hex: "#142C45",
            
          },400:{
            name: "blue.400",
            hex: "#285685",
            
          },500:{
            name: "blue.500",
            hex: "#4577AD",
            
          },600:{
            name: "blue.600",
            hex: "#6597CE",
            
          },700:{
            name: "blue.700",
            hex: "#96BDE7",
            
          },800:{
            name: "blue.800",
            hex: "#D1E8FF",
            
          }},
red : {100:{
            name: "red.100",
            hex: "#290F16",
            
          },200:{
            name: "red.200",
            hex: "#451522",
            
          },300:{
            name: "red.300",
            hex: "#5E1D2E",
            
          },400:{
            name: "red.400",
            hex: "#8F2843",
            
          },500:{
            name: "red.500",
            hex: "#B23655",
            
          },600:{
            name: "red.600",
            hex: "#C74C6B",
            
          },700:{
            name: "red.700",
            hex: "#EA8AA3",
            
          },800:{
            name: "red.800",
            hex: "#FFD1DD",
            
          }},
purple : {100:{
            name: "purple.100",
            hex: "#200F29",
            
          },200:{
            name: "purple.200",
            hex: "#33193F",
            
          },300:{
            name: "purple.300",
            hex: "#482359",
            
          },400:{
            name: "purple.400",
            hex: "#542F66",
            
          },500:{
            name: "purple.500",
            hex: "#693B80",
            
          },600:{
            name: "purple.600",
            hex: "#865C99",
            
          },700:{
            name: "purple.700",
            hex: "#B990CC",
            
          },800:{
            name: "purple.800",
            hex: "#F0D1FF",
            
          }},
orange : {100:{
            name: "orange.100",
            hex: "#29170C",
            
          },200:{
            name: "orange.200",
            hex: "#4A2915",
            
          },300:{
            name: "orange.300",
            hex: "#63371C",
            
          },400:{
            name: "orange.400",
            hex: "#8A4E29",
            
          },500:{
            name: "orange.500",
            hex: "#AD6234",
            
          },600:{
            name: "orange.600",
            hex: "#CF7945",
            
          },700:{
            name: "orange.700",
            hex: "#E7AA84",
            
          },800:{
            name: "orange.800",
            hex: "#FFE3D1",
            
          }},
grey : {100:{
            name: "grey.100",
            hex: "#141719",
            
          },200:{
            name: "grey.200",
            hex: "#1D2124",
            
          },300:{
            name: "grey.300",
            hex: "#22272B",
            
          },400:{
            name: "grey.400",
            hex: "#2D3238",
            
          },500:{
            name: "grey.500",
            hex: "#515357",
            
          },510:{
            name: "grey.510",
            hex: "#686B70",
            
          },600:{
            name: "grey.600",
            hex: "#98999B",
            
          },700:{
            name: "grey.700",
            hex: "#BCBDBF",
            
          },800:{
            name: "grey.800",
            hex: "#E8E9EA",
            
          }},
shades : {white:{
            name: "shades.white",
            hex: "#FFFFFF",
            
          },black:{
            name: "shades.black",
            hex: "#000000",
            
          },transparent:{
            name: "shades.transparent",
            hex: "transparent",
            
          }},
brown : {200:{
            name: "brown.200",
            hex: "#493612",
            
          },300:{
            name: "brown.300",
            hex: "#5E4317",
            
          },400:{
            name: "brown.400",
            hex: "#6B5024",
            
          },700:{
            name: "brown.700",
            hex: "#EFE5D1",
            
          },800:{
            name: "brown.800",
            hex: "#F6F1E5",
            
          }},
smart : {400:{
            name: "smart.400",
            hex: "#8FA7C1",
            
          },500:{
            name: "smart.500",
            hex: "#B0C1D4",
            
          },600:{
            name: "smart.600",
            hex: "#C8D6E4",
            
          },700:{
            name: "smart.700",
            hex: "#DDE5EE",
            
          }},};